export default "__VITE_ASSET__D00jOz3u__"